import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime/DateTime'

const renderList = (list) => {
  return (
    Object.keys(list).map(item => {
      return (<option key={list[item].id} value={list[item].id}>{list[item].name}</option>);
    })
  );
};

const PricePromotionsSearchPanel = (props) => {
  const {productValue, onProductChange, productList, groupValue, onGroupChange, groupList, displayFromDateValue,
    handleDisplayFromDateChange, displayToDateValue, handleDisplayToDateChange, onApply, onClearFilters} = props;
  return (
    <Panel className="order-filter">
      <Row>
        <Col md={6}>
          <FormGroup>
            <FormControl
              value={productValue}
              onChange={onProductChange}
              componentClass="select">
              <option value="">[Product]</option>
              { renderList(productList) }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <FormControl
              value={groupValue}
              onChange={onGroupChange}
              componentClass="select">
              <option value="">[Group]</option>
              { renderList(groupList) }
            </FormControl>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={displayFromDateValue}
              onChange={handleDisplayFromDateChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Display from date'
              }}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={displayToDateValue}
              onChange={handleDisplayToDateChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Display to date'
              }}/>
          </FormGroup>
        </Col>
        <Col md={4} className="actions">
          <Button
            className="red-ghost-btn"
            onClick={onApply}>Apply</Button>
          <Button
            className="red-ghost-btn"
            onClick={onClearFilters}>Clear filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default PricePromotionsSearchPanel;



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotions/list/price-promotions-search-panel.jsx